/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EnumTypZroje } from '../model';
// @ts-ignore
import { LayerSchemaVO } from '../model';
// @ts-ignore
import { VrstvaSimpleVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * GmlExportControllerApi - axios parameter creator
 * @export
 */
export const GmlExportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LayerSchemaVO} [layerSchemaVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVrstvaFromXsd: async (layerSchemaVO?: LayerSchemaVO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gml/create-vrstva-from-xsd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(layerSchemaVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vrstvaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAllObjektVrstva: async (vrstvaId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vrstvaId' is not null or undefined
            assertParamExists('exportAllObjektVrstva', 'vrstvaId', vrstvaId)
            const localVarPath = `/api/gml/vrstva/{vrstvaId}/export-all-objekt`
                .replace(`{${"vrstvaId"}}`, encodeURIComponent(String(vrstvaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vrstvaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportChangeObjektVrstva: async (vrstvaId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vrstvaId' is not null or undefined
            assertParamExists('exportChangeObjektVrstva', 'vrstvaId', vrstvaId)
            const localVarPath = `/api/gml/vrstva/{vrstvaId}/export-change-objekt`
                .replace(`{${"vrstvaId"}}`, encodeURIComponent(String(vrstvaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVrstvyPracovnika: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gml/vrstva/find-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumTypZroje} [typZdroje] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nactiStrukturuXsd: async (typZdroje?: EnumTypZroje, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gml/nacti-strukturu-xsd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typZdroje !== undefined) {
                localVarQueryParameter['typZdroje'] = typZdroje;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GmlExportControllerApi - functional programming interface
 * @export
 */
export const GmlExportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GmlExportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LayerSchemaVO} [layerSchemaVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVrstvaFromXsd(layerSchemaVO?: LayerSchemaVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.createVrstvaFromXsd(layerSchemaVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vrstvaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAllObjektVrstva(vrstvaId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAllObjektVrstva(vrstvaId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vrstvaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportChangeObjektVrstva(vrstvaId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.exportChangeObjektVrstva(vrstvaId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVrstvyPracovnika(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VrstvaSimpleVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getVrstvyPracovnika(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EnumTypZroje} [typZdroje] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nactiStrukturuXsd(typZdroje?: EnumTypZroje, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LayerSchemaVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.nactiStrukturuXsd(typZdroje, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GmlExportControllerApi - factory interface
 * @export
 */
export const GmlExportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GmlExportControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {LayerSchemaVO} [layerSchemaVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVrstvaFromXsd(layerSchemaVO?: LayerSchemaVO, options?: any): AxiosPromise<void> {
            return localVarFp.createVrstvaFromXsd(layerSchemaVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vrstvaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAllObjektVrstva(vrstvaId: number, options?: any): AxiosPromise<string> {
            return localVarFp.exportAllObjektVrstva(vrstvaId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vrstvaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportChangeObjektVrstva(vrstvaId: number, options?: any): AxiosPromise<string> {
            return localVarFp.exportChangeObjektVrstva(vrstvaId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVrstvyPracovnika(options?: any): AxiosPromise<Array<VrstvaSimpleVO>> {
            return localVarFp.getVrstvyPracovnika(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumTypZroje} [typZdroje] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nactiStrukturuXsd(typZdroje?: EnumTypZroje, options?: any): AxiosPromise<Array<LayerSchemaVO>> {
            return localVarFp.nactiStrukturuXsd(typZdroje, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GmlExportControllerApi - interface
 * @export
 * @interface GmlExportControllerApi
 */
export interface GmlExportControllerApiInterface {
    /**
     * 
     * @param {LayerSchemaVO} [layerSchemaVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmlExportControllerApiInterface
     */
    createVrstvaFromXsd(layerSchemaVO?: LayerSchemaVO, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {number} vrstvaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmlExportControllerApiInterface
     */
    exportAllObjektVrstva(vrstvaId: number, options?: any): AxiosPromise<string>;

    /**
     * 
     * @param {number} vrstvaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmlExportControllerApiInterface
     */
    exportChangeObjektVrstva(vrstvaId: number, options?: any): AxiosPromise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmlExportControllerApiInterface
     */
    getVrstvyPracovnika(options?: any): AxiosPromise<Array<VrstvaSimpleVO>>;

    /**
     * 
     * @param {EnumTypZroje} [typZdroje] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmlExportControllerApiInterface
     */
    nactiStrukturuXsd(typZdroje?: EnumTypZroje, options?: any): AxiosPromise<Array<LayerSchemaVO>>;

}

/**
 * GmlExportControllerApi - object-oriented interface
 * @export
 * @class GmlExportControllerApi
 * @extends {BaseAPI}
 */
export class GmlExportControllerApi extends BaseAPI implements GmlExportControllerApiInterface {
    /**
     * 
     * @param {LayerSchemaVO} [layerSchemaVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmlExportControllerApi
     */
    public createVrstvaFromXsd(layerSchemaVO?: LayerSchemaVO, options?: any) {
        return GmlExportControllerApiFp(this.configuration).createVrstvaFromXsd(layerSchemaVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vrstvaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmlExportControllerApi
     */
    public exportAllObjektVrstva(vrstvaId: number, options?: any) {
        return GmlExportControllerApiFp(this.configuration).exportAllObjektVrstva(vrstvaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vrstvaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmlExportControllerApi
     */
    public exportChangeObjektVrstva(vrstvaId: number, options?: any) {
        return GmlExportControllerApiFp(this.configuration).exportChangeObjektVrstva(vrstvaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmlExportControllerApi
     */
    public getVrstvyPracovnika(options?: any) {
        return GmlExportControllerApiFp(this.configuration).getVrstvyPracovnika(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumTypZroje} [typZdroje] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmlExportControllerApi
     */
    public nactiStrukturuXsd(typZdroje?: EnumTypZroje, options?: any) {
        return GmlExportControllerApiFp(this.configuration).nactiStrukturuXsd(typZdroje, options).then((request) => request(this.axios, this.basePath));
    }
}
